// extracted by mini-css-extract-plugin
module.exports = {"expandableGallery":"expandable-gallery-module--expandable-gallery--Bxnj0"};